module.exports = __webpack_public_path__ + "img/EA165&166_1-1.c121a079.jpg";